import { useSupabaseTable } from './useSupabaseTable';

export function useUnidadesNegocio() {
  return useSupabaseTable('unidades_negocio', { orderBy: 'nome', ascending: true });
}
